import React from 'react';
import {Provider} from "components/device/DeviceContext";
import {DeviceList} from "components/device/DeviceList";

export const Devices = () => {

    return (
        <Provider>
            <DeviceList/>
        </Provider>
    );
}
